import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import { Button } from './ui/Button'; // (Temporarily unused while Resume button is hidden)
import { cn } from '../lib/utils';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/contact', label: 'Contact' },
];

export const Navbar: React.FC = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur bg-black/30 border-b border-white/10">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="text-lg font-bold tracking-wide flex items-center gap-2 group" aria-label="Cheech home">
          <span className="relative inline-block">
            <span className="absolute inset-0 rounded-md bg-gradient-conic opacity-40 blur-md group-hover:opacity-60 transition-opacity" />
            <span className="relative text-gradient p-10 [@supports(not(-webkit-background-clip:text))]:text-brand-400">Christopher Bachicha</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map(l => (
            <Link
              key={l.to}
              to={l.to}
              className={cn(
                'text-sm font-medium transition-colors hover:text-white/90',
                pathname === l.to ? 'text-white' : 'text-white/60'
              )}
            >
              {l.label}
            </Link>
          ))}
          {/* Resume button temporarily removed
          <Button variant="outline" className="shadow-glow">Resume</Button>
          */}
        </nav>
        <button
          onClick={() => setOpen(o => !o)}
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
          aria-label="Toggle menu"
        >
          <span className="sr-only">Menu</span>
          <div className="space-y-1.5">
            <span className={cn('block h-0.5 w-6 bg-current transition-transform', open && 'translate-y-2 rotate-45')} />
            <span className={cn('block h-0.5 w-6 bg-current', open && 'opacity-0')} />
            <span className={cn('block h-0.5 w-6 bg-current transition-transform', open && '-translate-y-2 -rotate-45')} />
          </div>
        </button>
      </div>
      {open && (
        <div className="md:hidden animate-fade-in border-t border-white/10 bg-black/70 backdrop-blur">
          <div className="container py-4 flex flex-col gap-2">
            {navLinks.map(l => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={cn(
                  'py-2 rounded-md px-2 text-sm font-medium transition-colors',
                  pathname === l.to ? 'bg-white/10 text-white' : 'text-white/70 hover:text-white hover:bg-white/5'
                )}
              >
                {l.label}
              </Link>
            ))}
            {/* Resume button temporarily removed (mobile)
            <Button variant="outline" className="mt-2" onClick={() => setOpen(false)}>Resume</Button>
            */}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
